import SLinking from "./SLinking_web"
export default SLinking
